module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/GridItem3-8b592dfc57456097176cca4c2911a6ec.webp";